import { Checkbox, DatePicker, Form, Select, FormInstance, Row } from "antd";
import {
  DATE_FORMAT,
  DISBURSEMENTS_STATUS,
} from "../../../../../../../../../lib/constants";
import { useCallback, useMemo } from "react";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { TPayeeStatusState } from "../types";

type StatusPartProps = {
  form: FormInstance;
  payeeStatusState: TPayeeStatusState;
  setPayeeStatusState: React.Dispatch<React.SetStateAction<TPayeeStatusState>>;
};

export const StatusPart = ({
  form,
  payeeStatusState,
  setPayeeStatusState,
}: StatusPartProps) => {
  const isCheckboxDisabled: boolean = useMemo(
    () =>
      !payeeStatusState.isActive &&
      !payeeStatusState.isAmountNonNullOrZero &&
      !payeeStatusState.isEnableForPayments,
    [payeeStatusState]
  );

  const options = useMemo(
    () => DISBURSEMENTS_STATUS.filter((option) => option.value !== 3),
    []
  );

  const onSelectChange = useCallback(
    (value: number) => {
      if (value === 2) {
        const isPercent = form.getFieldValue("amountSwitcher") === 2;

        form.setFieldValue("enableForPayments", false);
        form.setFieldValue(`${isPercent ? "percentage" : "amount"}`, 0);

        setPayeeStatusState({
          isActive: false,
          isAmountNonNullOrZero: false,
          isEnableForPayments: false,
        });
      } else {
        setPayeeStatusState((prev: any) => ({
          ...prev,
          isActive: true,
        }));
      }
    },
    [form, setPayeeStatusState]
  );

  const onCheckboxChange = useCallback(
    (e: CheckboxChangeEvent) =>
      setPayeeStatusState((prev: any) => ({
        ...prev,
        isEnableForPayments: e.target.checked,
      })),
    [setPayeeStatusState]
  );

  return (
    <div className="pb-4">
      <p className="mb-4 mt-0 text-md w-500">Status</p>
      <Row>
        <Form.Item
          label="Status"
          name="status"
          className="w-100 mb-4"
          htmlFor=""
        >
          <Select options={options} onChange={onSelectChange} />
        </Form.Item>
        <Form.Item
          name="enableForPayments"
          className="w-100 ml-2 mt-6"
          valuePropName="checked"
        >
          <Checkbox disabled={isCheckboxDisabled} onChange={onCheckboxChange}>
            Enable for Payments
          </Checkbox>
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          label="Beginning Date"
          name="beginningDate"
          className="flex-grow-1 mb-4"
        >
          <DatePicker
            format={DATE_FORMAT}
            className="w-100"
            placeholder="MM/DD/YY"
          />
        </Form.Item>
        <Form.Item
          label="End Date"
          name="endDate"
          className="ml-2 mb-4 flex-grow-1"
        >
          <DatePicker
            format={DATE_FORMAT}
            className="w-100"
            placeholder="MM/DD/YY"
          />
        </Form.Item>
      </Row>
    </div>
  );
};
